@if (vm(); as vm) {
    <div class="mobile-select">
        @if (hasHeader()) {
            <div class="mobile-select__header" (libAccessibleClick)="toggleIsSelectOpened()">
                <div class="mobile-select__header-title">
                    {{ vm.title }}

                    @if (multiple()) {
                        <p class="mobile-select__selected-count body-2" [class.visible]="vm.selectedOptions.length">
                            {{ vm.selectedOptions.length }}
                        </p>
                    }
                </div>
                <mat-icon class="mobile-select__icon" [class.opened]="vm.isSelectOpened" svgIcon="ico_caret_down" />
            </div>
        }

        <div class="mobile-select__body" [class.visible]="vm.isSelectOpened" [attr.aria-hidden]="!vm.isSelectOpened">
            @for (option of vm.options; track option.value) {
                <div class="mobile-select__item">
                    @if (multiple()) {
                        <mat-checkbox
                            disableRipple
                            [ariaLabel]="option.ariaLabel"
                            [checked]="vm.selectedOptions | includes: option.value"
                            [tabIndex]="vm.isSelectOpened ? 0 : -1"
                            (change)="toggleSelectOptions($event, option.value)"
                        >
                            {{ option.label }}
                        </mat-checkbox>
                    } @else {
                        <button class="checkbox-wrapper" type="button" (click)="toggleSelectOption(option.value)">
                            <mat-pseudo-checkbox
                                appearance="minimal"
                                [ariaLabel]="option.ariaLabel"
                                [state]="vm.selectedOption === option.value ? 'checked' : 'unchecked'"
                            />
                            <span class="body-0">{{ option.label }}</span>
                        </button>
                    }
                </div>
            }
            @if (!vm.options?.length) {
                <p>No options</p>
            }
        </div>
    </div>
}
